// Action Types
export const FETCH_BATCHES_REQUEST = 'FETCH_BATCHES_REQUEST';
export const FETCH_BATCHES_SUCCESS = 'FETCH_BATCHES_SUCCESS';
export const FETCH_BATCHES_FAILURE = 'FETCH_BATCHES_FAILURE';


// Action Creators
export const fetchBatchesRequest = () => ({ type: FETCH_BATCHES_REQUEST });
export const fetchBatchesSuccess = (data) => ({ type: FETCH_BATCHES_SUCCESS, payload: data });
export const fetchBatchesFailure = (error) => ({ type: FETCH_BATCHES_FAILURE, payload: error });
